import { memo } from 'react';
import { useHistory } from 'react-router-dom';
import { Breadcrumbs, Typography, Link as MuiLink, Stack, Skeleton, Alert } from '@mui/material';
import { HiArrowSmRight } from 'react-icons/hi';

function AppBreadcrumbs({
  links = [],
  current,
  isLoading = false,
  isError = false,
  errorMessage = 'Something went wrong',
}) {
  const history = useHistory();

  return (
    <Stack spacing={2}>
      {isError ? (
        <Alert severity="error">{errorMessage}</Alert>
      ) : isLoading ? (
        <Breadcrumbs
          separator={<HiArrowSmRight fontSize="small" />}
          aria-label="breadcrumb"
        ></Breadcrumbs>
      ) : (
        <Breadcrumbs separator={<HiArrowSmRight fontSize="small" />} aria-label="breadcrumb">
          {links.map((link, idx) => (
            <MuiLink
              underline="hover"
              key={link.to || idx}
              color="inherit"
              href={link.to}
              onClick={(e) => {
                e.preventDefault();
                history.push(link.to);
              }}
              role="button"
              className="text-gray-700 hover:text-gray-900 transition-colors"
            >
              {link.label}
            </MuiLink>
          ))}

          {current && (
            <Typography color="text.primary" className="text-gray-900 font-medium">
              {current}
            </Typography>
          )}
        </Breadcrumbs>
      )}
    </Stack>
  );
}

export default memo(AppBreadcrumbs);
